import React from "react";
import "./Notification_card.css";
import { FaEnvelope } from "react-icons/fa";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Notification_card({ id, title, date, message, onDelete }) {
  return (
    <section className="notification-card">
      <div className="card-left">
        <div className="notification-content">
          <div className="title_text_holder">
            <div className="icon-box">
              <FaEnvelope />
            </div>
            <h4>{title}</h4>
          </div>

          <span className="notification-date">{date}</span>
          <p>{message}</p>
        </div>
      </div>

      <FontAwesomeIcon
        icon={faTrashCan}
        className="delete-icon"
        onClick={() => onDelete(id)}
      />
    </section>
  );
}

export default Notification_card;